import React from 'react';
import { PulseLoader } from 'react-spinners';
export const LoadingSpinner = ({ loading }) => (React.createElement("div", { style: { top: '35%', left: '45%', position: 'absolute', zIndex: 10 } },
    React.createElement(PulseLoader, { className: "loader", loading: loading, size: 20 })));
//# sourceMappingURL=loading-spinner.js.map